class FooterCollectionDescription {
    constructor(parent) {
      if (!parent) {
        return;
      }
      this.parent = parent;
      this.init();
    }
  
    readMoreBtn = () => {
      let parent = this.parent;
      let readButtonSelector = qsa('.read_more_title .change_txt', parent);
      readButtonSelector.forEach(element => {
        element.addEventListener("click",(e) => {
          e.target.parentNode.classList?.toggle('active');
          if(e.target.parentNode.classList.contains('active')) {
            e.target.innerText = 'Read Less';
          }else {
            e.target.innerText = 'Read More';
          }
        })
      })
    }
  
    init = () => {
      this.readMoreBtn();
    }
  }
  
  new FooterCollectionDescription(qs('.footer-collection-description-js'));